var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnterTable = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.199,
    height: 88.125,
    viewBox: "0 0 99.199 88.125",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13058",
    "data-name": "Group 13058",
    transform: "translate(5458.599 -3041.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13055",
    "data-name": "Group 13055",
    transform: "translate(947.401 42.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12157",
    "data-name": "Path 12157",
    d: "M22.111,316.249H28.1v22.623H22.111Z",
    transform: "translate(-6423.827 2744.56)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12158",
    "data-name": "Path 12158",
    d: "M96.907,316.249h5.988v22.623H96.907Z",
    transform: "translate(-6484.132 2744.56)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12159",
    "data-name": "Path 12159",
    d: "M384.188,316.249h5.988v22.623h-5.988Z",
    transform: "translate(-6715.753 2744.56)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12160",
    "data-name": "Path 12160",
    d: "M458.983,316.249h5.988v22.623h-5.988Z",
    transform: "translate(-6776.056 2744.56)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12163",
    "data-name": "Path 12163",
    d: "M25.748,200.126H2.994a3,3,0,0,1-2.994-3V172.345a2.994,2.994,0,1,1,5.988,0V194.13h19.76a3,3,0,0,1,0,6Z",
    transform: "translate(-6406 2863)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12164",
    "data-name": "Path 12164",
    d: "M107.978,297.263h-5.987a3,3,0,0,1,0,6h5.987a3,3,0,0,0,0-6Z",
    transform: "translate(-6488.23 2759.867)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12165",
    "data-name": "Path 12165",
    d: "M366.648,200.126H389.4a3,3,0,0,0,2.994-3V172.345a2.994,2.994,0,1,0-5.988,0V194.13h-19.76a3,3,0,0,0,0,6Z",
    transform: "translate(-6699.197 2863)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12166",
    "data-name": "Path 12166",
    d: "M471.556,169.347a3,3,0,0,0-2.994,3V194.13h-.017v3a3,3,0,0,1-2.994,3h6.005a3,3,0,0,0,2.994-3V172.345A3,3,0,0,0,471.556,169.347Z",
    transform: "translate(-6781.352 2863)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12167",
    "data-name": "Path 12167",
    d: "M240.547,241.558h5.988v37.094h-5.988Z",
    transform: "translate(-6599.941 2804.78)",
    fill: "#565959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12168",
    "data-name": "Path 12168",
    d: "M96.2,427.049H3a3,3,0,0,1-3-3v0a3,3,0,0,1,3-3H96.2a3,3,0,0,1,3,3v0A3,3,0,0,1,96.2,427.049Z",
    transform: "translate(-6406 2660.061)",
    fill: "#565959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12169",
    "data-name": "Path 12169",
    d: "M471.632,421.053h-5.987a3,3,0,0,1,0,6h5.987a3,3,0,0,0,0-6Z",
    transform: "translate(-6781.428 2660.061)",
    fill: "#565959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12170",
    "data-name": "Path 12170",
    d: "M158.218,225H94.348v-6.26a4,4,0,0,1,4-4h55.871a4,4,0,0,1,4,4Z",
    transform: "translate(-6482.068 2826.404)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12171",
    "data-name": "Path 12171",
    d: "M378.46,214.737h-5.987a4,4,0,0,1,4,4V225h5.987V218.74a4,4,0,0,0-4-4Z",
    transform: "translate(-6706.307 2826.404)",
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "share",
    d: "M399.437-241.13v-8.24h.758a21.347,21.347,0,0,1,15.769,6.961l1.19,1.3v-4.374a15.038,15.038,0,0,0-15.038-15.038h-2.679v-8.24l-12.6,13.815Z",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, -5266.517, 3514.43)",
    fill: "#565959"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnterTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/enter-table.7ad021d075a726fdca0de8de4783418c.svg";